/** @format */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ReactPaginate from "react-paginate";
import localOriginCharges from "../../../Services/localOriginCharges";
import locationServices from "../../../Services/locationServices";
import { ChangeStatus } from "../../../Components";
import Loader from "../../../Components/Loader";
import { MdEdit } from "react-icons/md";
import Select from "react-select";
import { toast } from "react-toastify";

export const SeaOriginChargeList = () => {
  const [SeaOriginCourierChargeList, setSeaLocalOriginChargeList] = useState(
    []
  );
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [originCountryValue, setCountryValue] = useState("");
  const [loader, setLoader] = useState(true);
  const history = useHistory();

  const getSeaLocalOriginChargeList = () => {
    let param = { ...pagination, page: currentPage };
    localOriginCharges.getLocalOriginChargeSea(param).then((res) => {
      if (res.status) {
        setSeaLocalOriginChargeList(res.data);
        setPagination(res.pagination);
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let postData = {
      _id: isModalOpen._id,
      local_origin_charge_status:
        isModalOpen.local_origin_charge_status === "ACTIVE"
          ? "INACTIVE"
          : "ACTIVE",
    };
    localOriginCharges
      .updateLocalOriginChargeStatusSea(postData)
      .then((res) => {
        if (res.status) {
          setIsModalOpen(false);
          getSeaLocalOriginChargeList();
        }
      });
  };

  const getCountryList = () => {
    let param = {
      limit: 250,
      page: 1,
    };
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        let arry = [];
        // eslint-disable-next-line
        res.data.map((list) => {
          arry.push({ value: list._id, label: list.country_name, data: list });
        });
        let activeCountry = arry.filter(
          (item) => item.data.country_currency === "AED"
        );
        if (activeCountry.length) {
          onSelectCountry(activeCountry[0]);
        }
        setLoader(false);
        setCountryList(arry);
      } else {
        toast.error(res.message);
      }
    });
  };

  const onSelectCountry = (e) => {
    setCountryValue(e);
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  useEffect(() => {
    getSeaLocalOriginChargeList();
    getCountryList();
    // eslint-disable-next-line
  }, [currentPage]);


  return (
    <div className="row justify-content-center">
      <div className="col-lg-6">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="w-50">
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "calc(2.15rem + 2px)",
                      overflowY: "visible",
                    }),
                    control: (provider) => ({
                      ...provider,
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: "#a0b0ca",
                    }),
                  }}
                  value={originCountryValue}
                  onChange={(e) => onSelectCountry(e)}
                  options={countryList}
                  isDisabled
                />
              </div>
              <button
                className="btn btn-primary w-sm waves-effect waves-light"
                onClick={() => history.push("/add-sea-origin-charge")}
              >
                Add Sea Origin Courier Charge
              </button>
            </div>

            <div className="customTbl_lt">
              <div className="thead_left">
                <div>S no.</div>
                <div>Country</div>
                <div>BL Fee (Aed)</div>
                <div>Customs Docs (Aed)</div>
                <div>Transport ( S2D to Seaport) Aed</div>
                <div>Weighment Charges (Aed)</div>
                <div>Handling In/Out Per cbm</div>
                <div>Min Handling In/Out (Aed)</div>
                <div>Status</div>
                <div>Action</div>
              </div>

              <div className="tbody_left">
                {SeaOriginCourierChargeList.length > 0 &&
                  SeaOriginCourierChargeList.map((item, key) => (
                    <div key={key} className="tr">
                      <div className="text-body fw-bold">
                        {(pagination.page - 1) * pagination.limit + (key + 1)}
                      </div>
                      <div>{item.country.country_name}</div>
                      <div>{item.bl_fee}</div>
                      <div>{item.customs_docs}</div>
                      <div>{item.transport_s2d_to_seaport}</div>
                      <div>{item.weightment_charges}</div>
                      <div>{item.handling_in_out}</div>
                      <div>{item.min_handling_in_out}</div>
                      <div>
                        <span
                          className={
                            "badge rounded-pill font-size-12 pointer" +
                            (item.local_origin_charge_status === "ACTIVE"
                              ? " bg-success"
                              : " bg-soft-danger")
                          }
                          onClick={() => setIsModalOpen(item)}
                        >
                          {item.local_origin_charge_status}
                        </span>
                      </div>
                      <div>
                        {/* Button trigger modal */}
                        <MdEdit
                          className="pointer"
                          onClick={() =>
                            history.push(
                              "/edit-sea-origin-charge?id=" + item._id,
                              item
                            )
                          }
                          color="#0323fe"
                          size="25px"
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            {SeaOriginCourierChargeList.length <= 0 && !loader && (
              <div className="text-center w-100 bg-warning my-5">
                <h6 className="py-2"> list not available </h6>
              </div>
            )}
          </div>
          {SeaOriginCourierChargeList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src="assets/images/prev.svg"
                    height={15}
                    alt="not found"
                  />
                }
                forcePage={currentPage - 1}
                nextLabel={
                  <img
                    src="assets/images/next.svg"
                    height={15}
                    alt="not found"
                  />
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={"pagination"}
                activeClassName={"active"}
              />
            )}
          <Loader isShow={loader} />
        </div>
        {Boolean(isModalOpen) && (
          <ChangeStatus
            isOpen={Boolean(isModalOpen)}
            title="Update Status"
            message={`Are you sure want to ${
              isModalOpen.local_origin_charge_status === "ACTIVE"
                ? "Inactive"
                : "Active"
            } status?`}
            onSubmitEvent={() => onModalSubmit()}
            handleClose={() => setIsModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};
